/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Define the API spec to declare events for the StateAPI
 *
 * @class StateAPISpec
 * @hideconstructor
 * @classdesc
 */
define([
	'../../../../api/DashboardAPI',
	'../../../../lib/@waca/dashboard-common/dist/api/impl/CallbackInvoker'
], (DashboardAPI, CallbackInvoker) => {
	/**
	 * TODO: remove the usage of CallbackInvoker and one Event mechanism
	 */
	class StateAPISpec extends CallbackInvoker {

		constructor(options) {
			super(options);
		}

		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'State API',
					events:{
						actions: {
							setStatus: {
								eventName: 'status'
							},
							setError: {
								eventName: 'error'
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}

	return StateAPISpec;
});